import { render, staticRenderFns } from "./addRule.vue?vue&type=template&id=96c43c50"
import script from "./addRule.vue?vue&type=script&lang=js"
export * from "./addRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96c43c50')) {
      api.createRecord('96c43c50', component.options)
    } else {
      api.reload('96c43c50', component.options)
    }
    module.hot.accept("./addRule.vue?vue&type=template&id=96c43c50", function () {
      api.rerender('96c43c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataprivilegerules/addRule.vue"
export default component.exports